<script setup lang="ts">
import { FormLabel } from "../../../base-components/Form";
import LoadingIcon from "../../../base-components/LoadingIcon";
import Button from "../../../base-components/Button";
import Preview from "../../../base-components/Preview";
import Litepicker from "../../../base-components/Litepicker";
import { onBeforeMount, reactive, Ref, ref, toRefs } from "vue";
import { useMensajesStore } from "../../../services/mensajes";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { getFirstDayOfMonth, litePickerConfig } from "../../../utils/helper";
import { helpers } from "@vuelidate/validators";
import { getCurrentDate, validarFecha } from "../../../utils/fecha";
import useVuelidate from "@vuelidate/core";
import { usePedidosStore } from "../../../services/pedidos";
import "flatpickr/dist/flatpickr.css";

const mensajesStore = useMensajesStore();
const pedidosStore = usePedidosStore();
const router = useRouter();

const { filtros } = storeToRefs(pedidosStore);

const formData = reactive({
  fechaInicio: "",
  fechaFin: ""
});

const emit = defineEmits<{ (e: "cerrar"): void }>();

onBeforeMount(() => {
  if (filtros.value.fechaInicio === "null" || filtros.value.fechaInicio === "")
    filtros.value.fechaInicio = getFirstDayOfMonth();
  if (filtros.value.fechaFin === "null" || filtros.value.fechaFin === "")
    filtros.value.fechaFin = getCurrentDate();
});

const cargando = ref<boolean>(false);

const esCliente = ref(true);

const rules = {
  fechaInicio: {
    formato: helpers.withMessage(
      `Formato inválido (debe ser: dd/mm/aaaa)`,
      validarFecha
    )
  },
  fechaFin: {
    formato: helpers.withMessage(
      `Formato inválido (debe ser: dd/mm/aaaa)`,
      validarFecha
    )
  }
};

const validate$ = useVuelidate(rules, toRefs(filtros.value));

const cliente: Ref<string | null> = ref(null);

const handlerFiltrar = async () => {
  const result = await validate$.value.$validate();

  if (result) {
    cargando.value = true;

    filtros.value.fechaInicio = formData.fechaInicio;
    filtros.value.fechaFin = formData.fechaFin;

    mensajesStore.mostrarToast(
      "Filtrado con éxito",
      "...",
      mensajesStore.mensajeType.exito
    );
    emit("cerrar");
    // });
    cargando.value = false;
  }
};

const configHora = {
  enableTime: true,
  noCalendar: true,
  time_24hr: true,
  minuteIncrement: 1
};
</script>

<template>
  <Preview class="box">
    <form class="validate-form p-2" @submit.prevent="">
      <div
        class="border-b sm:flex-row border-slate-200/60 dark:border-darkmode-400"
      >
        <!-- Fecha comprobante -->
        <div class="col-span-12 lg:col-span-6 mt-3 mb-5">
          <div class="flex">
            <div class="flex-none w-50 text-right pr-5 mt-2">
              <FormLabel class="w-40 sw:w-20">Fecha</FormLabel>
            </div>

            <div class="w-1/3 flex justify-between">
              <div class="me-2 min-w-28">
                <Litepicker
                  v-model="formData.fechaInicio"
                  :options="litePickerConfig"
                  :class="{
                    'border-danger': validate$.fechaInicio.$error
                  }"
                />

                <template v-if="validate$.fechaInicio?.$error">
                  <div
                    v-for="(error, index) in validate$.fechaInicio.$errors"
                    :key="index"
                    class="mt-2 text-danger"
                  >
                    {{ error.$message }}
                  </div>
                </template>
              </div>

              <div class="m-2 flex items-center">-</div>

              <div class="ms-2 min-w-28">
                <div class="me-2 min-w-28">
                  <Litepicker
                    v-model="formData.fechaFin"
                    :options="litePickerConfig"
                    :class="{
                      'border-danger': validate$.fechaFin.$error
                    }"
                  />
                </div>

                <template v-if="validate$.fechaFin?.$error">
                  <div
                    v-for="(error, index) in validate$.fechaFin.$errors"
                    :key="index"
                    class="mt-2 text-danger"
                  >
                    {{ error.$message }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!cargando" class="flex mt-6">
        <div class="flex-1 text-left mt-3">
          <Button
            variant="secondary"
            class="mb-2 mr-1"
            @click="
              () => {
                emit('cerrar');
              }
            "
          >
            Cancelar</Button
          >
        </div>
        <div class="flex-1 text-right">
          <Button
            variant="primary"
            class="mb-2 mr-1 mt-3"
            @click="handlerFiltrar"
          >
            Filtrar
          </Button>
        </div>
      </div>
      <div v-else class="flex my-6">
        <div class="mx-auto">
          <LoadingIcon icon="oval" class="w-8 h-8" />
        </div>
      </div>
    </form>
  </Preview>
</template>

<style scoped>
:deep(.ts-dropdown) {
  max-height: 12rem;
  overflow-y: auto;
}
</style>
